import { UserCapabilityName } from '../types/userCapabilityName';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
}

export interface ICapabilitiesForUser {
  __typename?: 'CapabilitiesForUser';
  capabilities: Array<ICapability>;
  userId: Scalars['String']['output'];
}

export interface ICapability {
  __typename?: 'Capability';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
}

export interface ICreateProgressiveDeliveryConfigInput {
  rolloutStages: Array<IRolloutStageInput>;
  toggleName: Scalars['String']['input'];
}

export interface IFeatureToggle {
  __typename?: 'FeatureToggle';
  category: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgCount: Scalars['Int']['output'];
  progressiveDeliveryPercentage?: Maybe<Scalars['Int']['output']>;
  progressiveDeliveryStatus?: Maybe<ProgressiveDeliveryStatus>;
  updatedAt: Scalars['String']['output'];
  userCount: Scalars['Int']['output'];
}

export interface IFeatureToggleDetailsResponse {
  __typename?: 'FeatureToggleDetailsResponse';
  category: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  progressiveDeliveryAssignmentCount?: Maybe<Scalars['Int']['output']>;
  progressiveDeliveryPercentage?: Maybe<Scalars['Int']['output']>;
  progressiveDeliveryStatus?: Maybe<ProgressiveDeliveryStatus>;
  selectedOrgs: Array<IFeatureToggleOrg>;
  selectedUsers: Array<IFeatureToggleUser>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
}

export interface IFeatureToggleInput {
  category: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  selectedOrgs: Array<Scalars['String']['input']>;
  selectedUsers: Array<Scalars['String']['input']>;
}

export interface IFeatureToggleOrg {
  __typename?: 'FeatureToggleOrg';
  name: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
}

export interface IFeatureToggleUser {
  __typename?: 'FeatureToggleUser';
  fullName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
}

export interface IFeatureTogglesResponse {
  __typename?: 'FeatureTogglesResponse';
  featureToggles: Array<IFeatureToggle>;
}

export interface IGqlError {
  __typename?: 'GqlError';
  extensions?: Maybe<IGqlErrorExtensions>;
  locations?: Maybe<Array<IGqlErrorSourceLocation>>;
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
}

export interface IGqlErrorExtensions {
  __typename?: 'GqlErrorExtensions';
  code?: Maybe<Scalars['String']['output']>;
}

export interface IGqlErrorSourceLocation {
  __typename?: 'GqlErrorSourceLocation';
  column: Scalars['Int']['output'];
  line: Scalars['Int']['output'];
}

export interface IMetricsBucket {
  __typename?: 'MetricsBucket';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
}

export interface IMutateFeatureToggleResponse {
  __typename?: 'MutateFeatureToggleResponse';
  name: Scalars['String']['output'];
}

export interface IMutation {
  __typename?: 'Mutation';
  createFeatureToggle: IMutateFeatureToggleResponse;
  createProgressiveDeliveryConfig: IProgressiveDeliveryDetail;
  deleteFeatureToggle: IMutateFeatureToggleResponse;
  deleteProgressiveDeliveryConfig: IProgressiveDeliveryDetail;
  setProgressiveDeliveryBlackoutDays: Array<Scalars['String']['output']>;
  updateFeatureToggle: IMutateFeatureToggleResponse;
  updateProgressiveDeliveryConfig: IProgressiveDeliveryDetail;
}


export interface IMutationCreateFeatureToggleArgs {
  input: IFeatureToggleInput;
}


export interface IMutationCreateProgressiveDeliveryConfigArgs {
  input: ICreateProgressiveDeliveryConfigInput;
}


export interface IMutationDeleteFeatureToggleArgs {
  name: Scalars['String']['input'];
}


export interface IMutationDeleteProgressiveDeliveryConfigArgs {
  toggleName: Scalars['String']['input'];
}


export interface IMutationSetProgressiveDeliveryBlackoutDaysArgs {
  dates: Array<Scalars['String']['input']>;
}


export interface IMutationUpdateFeatureToggleArgs {
  input: IFeatureToggleInput;
}


export interface IMutationUpdateProgressiveDeliveryConfigArgs {
  input: IUpdateProgressiveDeliveryConfigInput;
}

export interface IOrganization {
  __typename?: 'Organization';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface IOrganizationPagination {
  __typename?: 'OrganizationPagination';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

export interface IOrganizationsWithPagination {
  __typename?: 'OrganizationsWithPagination';
  organizations: Array<IOrganization>;
  pagination: IOrganizationPagination;
}

export interface IProgressiveDeliveryCalendar {
  __typename?: 'ProgressiveDeliveryCalendar';
  blackoutDays: Array<Scalars['String']['output']>;
  rollouts: Array<IProgressiveDeliveryRollout>;
}

export interface IProgressiveDeliveryDetail {
  __typename?: 'ProgressiveDeliveryDetail';
  assignmentCount: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  currentStageIndex: Scalars['Int']['output'];
  pausedAt?: Maybe<Scalars['String']['output']>;
  regionDistribution: Array<IMetricsBucket>;
  rolloutStages: Array<IRolloutStage>;
  stageStartedAt?: Maybe<Scalars['String']['output']>;
  status: ProgressiveDeliveryStatus;
  toggleName: Scalars['String']['output'];
  totalOrgCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
}

export interface IProgressiveDeliveryListItem {
  __typename?: 'ProgressiveDeliveryListItem';
  assignmentCount: Scalars['Int']['output'];
  currentPercentage: Scalars['Int']['output'];
  currentStageIndex: Scalars['Int']['output'];
  status: ProgressiveDeliveryStatus;
  toggleName: Scalars['String']['output'];
  totalStages: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
}

export interface IProgressiveDeliveryRollout {
  __typename?: 'ProgressiveDeliveryRollout';
  currentStageIndex: Scalars['Int']['output'];
  pausedAt?: Maybe<Scalars['String']['output']>;
  rolloutStages: Array<IRolloutStage>;
  stageStartedAt?: Maybe<Scalars['String']['output']>;
  status: ProgressiveDeliveryStatus;
  toggleName: Scalars['String']['output'];
}

export enum ProgressiveDeliveryStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Inactive = 'INACTIVE',
  Paused = 'PAUSED',
  RolledBack = 'ROLLED_BACK'
}

export interface IQuery {
  __typename?: 'Query';
  allCapabilitiesForUser?: Maybe<ICapabilitiesForUser>;
  allOrganizationDisplays: IOrganizationsWithPagination;
  allUsers?: Maybe<IUsersWithPagination>;
  getFeatureToggleDetails: IFeatureToggleDetailsResponse;
  getFeatureToggles: IFeatureTogglesResponse;
  getProgressiveDeliveryCalendar: IProgressiveDeliveryCalendar;
  getProgressiveDeliveryDetail: IProgressiveDeliveryDetail;
  getProgressiveDeliveryList: Array<IProgressiveDeliveryListItem>;
  self?: Maybe<ISelf>;
}


export interface IQueryAllOrganizationDisplaysArgs {
  all?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryAllUsersArgs {
  all?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}


export interface IQueryGetFeatureToggleDetailsArgs {
  name: Scalars['String']['input'];
}


export interface IQueryGetProgressiveDeliveryDetailArgs {
  toggleName: Scalars['String']['input'];
}

export interface IRolloutStage {
  __typename?: 'RolloutStage';
  durationDays: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
}

export interface IRolloutStageInput {
  durationDays: Scalars['Int']['input'];
  percentage: Scalars['Int']['input'];
}

export interface ISelf {
  __typename?: 'Self';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pid: Scalars['String']['output'];
}

export interface IUpdateProgressiveDeliveryConfigInput {
  rolloutStages?: InputMaybe<Array<IRolloutStageInput>>;
  status?: InputMaybe<ProgressiveDeliveryStatus>;
  toggleName: Scalars['String']['input'];
}

export interface IUser {
  __typename?: 'User';
  accessPolicyIds?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface IUserBasicInfo {
  __typename?: 'UserBasicInfo';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
}

export { UserCapabilityName };

export interface IUserPagination {
  __typename?: 'UserPagination';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
}

export interface IUsersWithPagination {
  __typename?: 'UsersWithPagination';
  pagination: IUserPagination;
  users: Array<IUserBasicInfo>;
}

export type IAllCapabilitiesForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type IAllCapabilitiesForUserQuery = { __typename?: 'Query', allCapabilitiesForUser?: { __typename?: 'CapabilitiesForUser', userId: string, capabilities: Array<{ __typename?: 'Capability', name?: string | null, id?: string | null }> } | null };

export type IAllOrganizationDisplaysQueryVariables = Exact<{
  all?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type IAllOrganizationDisplaysQuery = { __typename?: 'Query', allOrganizationDisplays: { __typename?: 'OrganizationsWithPagination', organizations: Array<{ __typename?: 'Organization', id: string, name: string }>, pagination: { __typename?: 'OrganizationPagination', offset: number, limit: number, total: number } } };

export type IAllUsersQueryVariables = Exact<{
  all?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type IAllUsersQuery = { __typename?: 'Query', allUsers?: { __typename?: 'UsersWithPagination', users: Array<{ __typename?: 'UserBasicInfo', id: string, firstName: string, lastName: string, email: string }>, pagination: { __typename?: 'UserPagination', offset: number, limit: number, total: number } } | null };

export type ICreateFeatureToggleMutationVariables = Exact<{
  input: IFeatureToggleInput;
}>;


export type ICreateFeatureToggleMutation = { __typename?: 'Mutation', createFeatureToggle: { __typename?: 'MutateFeatureToggleResponse', name: string } };

export type ICreateProgressiveDeliveryConfigMutationVariables = Exact<{
  input: ICreateProgressiveDeliveryConfigInput;
}>;


export type ICreateProgressiveDeliveryConfigMutation = { __typename?: 'Mutation', createProgressiveDeliveryConfig: { __typename?: 'ProgressiveDeliveryDetail', toggleName: string, currentStageIndex: number, status: ProgressiveDeliveryStatus, assignmentCount: number, totalOrgCount: number, createdAt: string, createdBy: string, updatedAt: string, updatedBy: string, rolloutStages: Array<{ __typename?: 'RolloutStage', percentage: number, durationDays: number }>, regionDistribution: Array<{ __typename?: 'MetricsBucket', label: string, count: number }> } };

export type IDeleteFeatureToggleMutationVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type IDeleteFeatureToggleMutation = { __typename?: 'Mutation', deleteFeatureToggle: { __typename?: 'MutateFeatureToggleResponse', name: string } };

export type IDeleteProgressiveDeliveryConfigMutationVariables = Exact<{
  toggleName: Scalars['String']['input'];
}>;


export type IDeleteProgressiveDeliveryConfigMutation = { __typename?: 'Mutation', deleteProgressiveDeliveryConfig: { __typename?: 'ProgressiveDeliveryDetail', toggleName: string, status: ProgressiveDeliveryStatus } };

export type IGetFeatureToggleDetailsQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type IGetFeatureToggleDetailsQuery = { __typename?: 'Query', getFeatureToggleDetails: { __typename?: 'FeatureToggleDetailsResponse', name: string, isEnabled: boolean, category: string, clientId: string, description?: string | null, progressiveDeliveryStatus?: ProgressiveDeliveryStatus | null, progressiveDeliveryPercentage?: number | null, progressiveDeliveryAssignmentCount?: number | null, createdAt?: string | null, createdBy?: string | null, updatedAt?: string | null, updatedBy?: string | null, selectedUsers: Array<{ __typename?: 'FeatureToggleUser', userId: string, fullName: string }>, selectedOrgs: Array<{ __typename?: 'FeatureToggleOrg', orgId: string, name: string }> } };

export type IGetFeatureTogglesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetFeatureTogglesQuery = { __typename?: 'Query', getFeatureToggles: { __typename?: 'FeatureTogglesResponse', featureToggles: Array<{ __typename?: 'FeatureToggle', name: string, isEnabled: boolean, category: string, clientId: string, description?: string | null, progressiveDeliveryStatus?: ProgressiveDeliveryStatus | null, progressiveDeliveryPercentage?: number | null, userCount: number, orgCount: number, updatedAt: string }> } };

export type IGetProgressiveDeliveryCalendarQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetProgressiveDeliveryCalendarQuery = { __typename?: 'Query', getProgressiveDeliveryCalendar: { __typename?: 'ProgressiveDeliveryCalendar', blackoutDays: Array<string>, rollouts: Array<{ __typename?: 'ProgressiveDeliveryRollout', toggleName: string, status: ProgressiveDeliveryStatus, currentStageIndex: number, stageStartedAt?: string | null, pausedAt?: string | null, rolloutStages: Array<{ __typename?: 'RolloutStage', percentage: number, durationDays: number }> }> } };

export type IGetProgressiveDeliveryDetailQueryVariables = Exact<{
  toggleName: Scalars['String']['input'];
}>;


export type IGetProgressiveDeliveryDetailQuery = { __typename?: 'Query', getProgressiveDeliveryDetail: { __typename?: 'ProgressiveDeliveryDetail', toggleName: string, currentStageIndex: number, stageStartedAt?: string | null, pausedAt?: string | null, status: ProgressiveDeliveryStatus, assignmentCount: number, totalOrgCount: number, createdAt: string, createdBy: string, updatedAt: string, updatedBy: string, rolloutStages: Array<{ __typename?: 'RolloutStage', percentage: number, durationDays: number }>, regionDistribution: Array<{ __typename?: 'MetricsBucket', label: string, count: number }> } };

export type IGetProgressiveDeliveryListQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetProgressiveDeliveryListQuery = { __typename?: 'Query', getProgressiveDeliveryList: Array<{ __typename?: 'ProgressiveDeliveryListItem', toggleName: string, currentPercentage: number, currentStageIndex: number, totalStages: number, status: ProgressiveDeliveryStatus, assignmentCount: number, updatedAt: string }> };

export type ISelfQueryVariables = Exact<{ [key: string]: never; }>;


export type ISelfQuery = { __typename?: 'Query', self?: { __typename?: 'Self', id: string, firstName: string, lastName: string, email: string, phone: string, pid: string } | null };

export type ISetProgressiveDeliveryBlackoutDaysMutationVariables = Exact<{
  dates: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ISetProgressiveDeliveryBlackoutDaysMutation = { __typename?: 'Mutation', setProgressiveDeliveryBlackoutDays: Array<string> };

export type IUpdateFeatureToggleMutationVariables = Exact<{
  input: IFeatureToggleInput;
}>;


export type IUpdateFeatureToggleMutation = { __typename?: 'Mutation', updateFeatureToggle: { __typename?: 'MutateFeatureToggleResponse', name: string } };

export type IUpdateProgressiveDeliveryConfigMutationVariables = Exact<{
  input: IUpdateProgressiveDeliveryConfigInput;
}>;


export type IUpdateProgressiveDeliveryConfigMutation = { __typename?: 'Mutation', updateProgressiveDeliveryConfig: { __typename?: 'ProgressiveDeliveryDetail', toggleName: string, currentStageIndex: number, stageStartedAt?: string | null, pausedAt?: string | null, status: ProgressiveDeliveryStatus, assignmentCount: number, totalOrgCount: number, createdAt: string, createdBy: string, updatedAt: string, updatedBy: string, rolloutStages: Array<{ __typename?: 'RolloutStage', percentage: number, durationDays: number }>, regionDistribution: Array<{ __typename?: 'MetricsBucket', label: string, count: number }> } };
